 /**
 * Created by Shiv Roy on 21/11/17.
 */
import { showFormatedDate, showFormattedTime, base64Encode, showFormatedDateandTime } from '../../../../actions/utilAction';
import classNames from 'classnames';
import { renderCheckBox, renderTextField, renderTimePicker, renderTextArea, renderDateField } from '../../../../components/reduxFields';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { CommonButton } from '../../../../components/buttons';
import { connect } from 'react-redux';
// import PatientInfo from '../../patient_info';
import React from 'react';
import history from '../../../../history';
import moment from 'moment';
import { getMasterData} from '../../../scheduling/components/SessionNotes_EBS/actions/soapActions';


import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
} from 'material-ui/Table';

import { getPatientSingleEncounters } from '../../actions/PatientActions';

class EncounterForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      apptid: props.match.params.apptid,
      encid: props.match.params.id,
      patientId: null,
      appointmentTypeName: '',
      appointmentDate: null,
      appointmentTime: null,
      staffName: '',
      serviceFacility: '',
      isDirectService: false,
      PatientLocationName: '',
      EmployeeSign: { Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      ClientSign: { Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      GuardianSign: { Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      timeDifference: 0.0,
      master_data: props.master_data,
    };
    this.handleBackClick = this.handleBackClick.bind(this);
  }

  componentWillMount() {
    this.props.getMasterData();
    let searchObj = {
      'apptId': this.state.apptid,
      'encounterId': this.state.encid,
    };
    this.props.getPatientSingleEncounters(searchObj);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.singleEncounter && this.props.singleEncounter !== nextProps.singleEncounter) {
      let appointmentData = nextProps.singleEncounter.patientAppointment;
      if (appointmentData) {
        let staffNames = [];
        appointmentData.appointmentSingleStaff.forEach((staff) => {
          staffNames.push(staff.staffName);
        });
        this.setState({
          patientId: appointmentData.patientID,
          appointmentTypeName: appointmentData.appointmentTypeName,
          appointmentDate: showFormatedDate(appointmentData.startDateTime),
          appointmentTime: showFormattedTime(appointmentData.startDateTime) + ' - ' + showFormattedTime(appointmentData.endDateTime),
          staffName: staffNames && staffNames ? staffNames.join(',') : '',
          serviceFacility: appointmentData.serviceFacility,
          isDirectService: appointmentData.isDirectService,
          PatientLocationName: appointmentData.address,
          timeDifference: appointmentData.timeDifference,        
        });

        let soapObj = nextProps.singleEncounter;
        let guardianSignObj = {}, clientSignObj = {}, employeeSignObj = {};
        if (soapObj.encounterSignature) {
          (soapObj.encounterSignature || []).forEach((signObj) => {
            if (signObj.guardianSign) {
              let data = {
                Bytes: signObj.guardianSign,
                Date: signObj.guardianSignDate,
                Name: signObj.guardianName,
                Latitude: signObj.latitude, 
                Longitude: signObj.longitude,
              };
              guardianSignObj = data;
            }
            if (signObj.patientSign) {
              let data = {
                Bytes: signObj.patientSign,
                Date: signObj.patientSignDate,
                Name: nextProps.singleEncounter.patientName,
                Latitude: signObj.latitude, 
                Longitude: signObj.longitude,
              };
              clientSignObj = data;
            }
            if (signObj.clinicianSign) {
              let data = {
                Bytes: signObj.clinicianSign,
                Date: signObj.clinicianSignDate,
                Name: staffNames && staffNames ? staffNames.join(',') : '',
                Latitude: signObj.latitude, 
                Longitude: signObj.longitude,
              };
              employeeSignObj = data;
            }
          });
        }
        this.setState({
          ClientSign: clientSignObj,
          GuardianSign: guardianSignObj,
          EmployeeSign: employeeSignObj,
        });
      }
    }

    if (nextProps.master_data && this.props.master_data !== nextProps.master_data) {
      this.setState({
        master_data: nextProps.master_data,     
      });
    }

    if (nextProps.dateOfNextSession && this.props.dateOfNextSession !== nextProps.dateOfNextSession) {   
      this.setState({ DateOfNextSession: nextProps.dateOfNextSession});     
    }
  }

  renderDiagnosis() {
    if (this.props.initialValues.diagnosisArray && this.props.initialValues.diagnosisArray.length === 0) {
      return (
        <tr><td className="text-center no-record">No record found.</td></tr>
      );
    } else {
      if (this.props.initialValues.diagnosisArray && this.props.initialValues.diagnosisArray.length !== 0) {
        return this.props.initialValues.diagnosisArray.map((diagnosis, index) => {
          if (diagnosis.IsDeleted) {
            return <tr key={index}><td colSpan='3'><span className='redfont'>{diagnosis.description}</span></td></tr>;
          }
          return (
            <tr key={index}>
              <td width="30%">{diagnosis.icdCode}</td>
              <td width="70%">{diagnosis.description ? diagnosis.description : ''}</td>
              {/* <td width="10%"><button onClick={(e) => this.handleRemoveDiagnosisClick(e, index)} title="Remove" type="button" className="tbactionbtn redfont">Remove</button></td>*/}
            </tr>
          );
        });
      }
    }
  }


  renderCpt() {
    if (this.props.initialValues.CPTTableData && this.props.initialValues.CPTTableData.length === 0) {
      return (
        <tr><td className="text-center no-record">No record found.</td></tr>
      );
    } else if (this.props.initialValues.CPTTableData && this.props.initialValues.CPTTableData.length !== 0) {
      return this.props.initialValues.CPTTableData.map((cpt, index) => {
        if (cpt.IsDeleted) {
          return <tr key={index}><td colSpan='3'><span className='redfont'>{cpt.serviceCode}</span></td></tr>;
        }
        return (
          <tr key={index}>
            <td width="20%">{cpt.serviceCode ? cpt.serviceCode : '-'}</td>
            <td width="30%">{cpt.attachedModifiers ? cpt.attachedModifiers : '-'}</td>
            <td width="50%">{cpt.description ? cpt.description : '-'}</td>
          </tr>
        );
      });
    }
  }

  handleBackClick = () => {
    let encPatientId = this.state.patientId ? base64Encode(`${this.state.patientId}`) : null;
    if (this.props.location.state && this.props.location.state.isRedirectFromPatientEncounter && encPatientId) {
      history.push(`/client/encounter/${encPatientId}`);
    } else {
      history.push('/dashboard');
    }
  };

  render() {
    const tableClass1 = classNames({
      'table': true,
      'customtable': true,
      'fixedheader': true,
      'table-hover': true,
    });

    let totalUnitsConsumed = (this.props.singleEncounter && this.props.singleEncounter.unitsConsumed) || 0;

    return (
      <div>
        {/* <h2 className="page_title">Client Encounter</h2>
        <PatientInfo patientId={this.state.patientid} />
        <div className="clearfix"></div> */}
        <div className="readmin-panel">
          <div className="panel-body">
            <form className="readmin-form custom_form">
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title no_margin mb-20">
                    <CommonButton label="Back" primary={true} onTouchTap={this.handleBackClick} />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title no_margin mb-20">
                    <h3>Appointment</h3>
                    <i className="flaticon flaticon-medical-4"></i>
                  </div>
                </div>
                <div className="col-sm-12 ml-20">
                  <div className="col-sm-12 soap_content">
                    <div className="soap_detail detail_wd">
                      <p>
                        <b>Appointment :</b> <span>{this.state.appointmentTypeName ? this.state.appointmentTypeName : '-'}</span>
                      </p>
                      <p>
                        <b>Appointment Date :</b> <span>{this.state.appointmentDate ? this.state.appointmentDate : '-'}</span>
                      </p>
                      <p>
                        <b>Appointment Time:</b> <span>{this.state.appointmentTime ? this.state.appointmentTime : '-'}</span>
                      </p>
                      <p>
                        <b>Seen By :</b> <span>{this.state.staffName ? this.state.staffName : '-'}</span>
                      </p>
                      <p>
                        <b>Location Type :</b> <span>{this.state.serviceFacility || '-'}</span>
                      </p>
                      <p>
                        <b>Service Type :</b> <span>{this.state.isDirectService ? 'Direct' : 'Indirect'}</span>
                      </p>
                      <p className="wd-100">
                        <b>Service Location :</b> <span>{this.state.PatientLocationName ? this.state.PatientLocationName : '-'}</span>
                      </p>
                      <p>
                        <b>Unit Billed :</b> <span>{totalUnitsConsumed}</span>
                      </p>
                      <p>
                        <b>Session Duration (In Mins):</b> <span>{this.state.timeDifference}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="clearfix"></div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h3>Service</h3>
                    <i className="flaticon flaticon-time-1"></i>
                  </div>
                </div>
                <div className="col-sm-6">
                  <Field
                    name="serviceStartTime"
                    placeholder="Start Time"
                    disabled={true}
                    fullWidth={true}
                    component={renderTimePicker}
                    selected={this.props.initialValues.serviceStartTime}
                    onDateChange={this.onDateChange}

                  />
                </div>
                <div className="col-sm-6">
                  <Field
                    name="serviceEndTime"
                    placeholder="End Time"
                    component={renderTimePicker}
                    selected={this.props.initialValues.serviceEndTime}
                    onDateChange={this.onDateChange}
                    disabled={true}
                    fullWidth={true}
                  />
                </div>
              </div>
              <div className ="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h3>Session Notes</h3>
                    <i className="flaticon flaticon-interface-2"></i>
                  </div>
                </div>    
                <div className={'col-sm-12 require'} >                    
                    <Field
                    name="ServiceCoordinatorName"
                    type="text"                   
                    label="Service Coordinator Name"
                    disabled={true}
                    component={renderTextField}                    
                    />
                  </div>   
                                    
              </div>
              <div className="row">
                <div className='col-sm-6 require mt-35'>
                  <div className="panel_title no_margin  mb-20">
                    <h5>Type Of Service:</h5>
                  </div>                  
                </div>
                <div className='col-sm-6'></div>
              </div>              
              <div className="row">
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="OT"
                    label="OT"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="PT"
                    label="PT"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ST"
                    label="ST"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="SI"
                    label="SI"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="OtherTypeofService"
                    label="Other"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                {this.props.selectorOtherTypeofService &&
                  (<div className='col-sm-4'>
                  <Field
                    name="OtherTypeofServiceNotes"
                    type="text"
                    fullWidth={true}
                    label="Other Notes"
                    disabled={true}
                    component={renderTextField}
                  />
                </div>)}
              </div>
              
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h5>Type Of Session:</h5>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Initial"
                    label="Initial"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Ongoing"
                    label="Ongoing"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>                          
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="OtherTypeofSession"
                    label="Other"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                {this.props.selectorOtherTypeofSession &&
                (<div className='col-sm-4'>
                  <Field
                    name="OtherTypeofSessionNotes"
                    type="text"
                    fullWidth={true}
                    label="Other Notes"
                    disabled={true}
                    component={renderTextField}
                  />
                </div>)}
              </div>
              
              <div className="row">
                <div className="col-sm-12">
                    <Field
                      name="Goals"
                      type="text"
                      fullWidth={true}
                      label="Outcome(s)/Goal(s) from IFSP/IEP"
                      rowsCount = {6}
                      // autoHeight={true}
                      disabled={true}
                      component={renderTextArea}                      
                    />
                  </div>
                  <div className="col-sm-12">
                    <Field
                      name="ChildOutcomeUpdate"
                      type="text"
                      fullWidth={true}
                      label="Child And Family Outcome Update"
                      rowsCount = {6}
                      // autoHeight={true}
                      disabled={true}
                      component={renderTextArea}                      
                    />
                  </div>
                  <div className="col-sm-12">
                    <Field
                      name="ActivitiesAndRoutines"
                      type="text"
                      fullWidth={true}
                      label="Activities And Routines, Family participation and how strategies were used"
                      rowsCount = {6}
                      // autoHeight={true}
                      disabled={true}
                      component={renderTextArea}                      
                    />
                  </div>
              </div>
              <div className="row">
                <div className="col-sm-12">                  
                    <div className="panel_title">
                      <h5>Strategies Used:</h5>
                    </div>                   
                </div>
              </div>
              <div className="row">
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="DirectTeaching"
                    label="Direct Teaching"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Demonstration"
                    label="Demonstration"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div> 
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="GuidedPractice"
                    label="Guided Practice"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="CaregiverPractice"
                    label="Caregiver Practice"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div> 
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ProblemSolving"
                    label="Problem Solving"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Reflection"
                    label="Reflection"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>                             
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="OtherStrategiesUsed"
                    label="Other"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                {this.props.selectorOtherStrategiesUsed &&
                (<div className='col-sm-4'>
                  <Field
                    name="OtherStrategiesUsedNotes"
                    type="text"
                    fullWidth={true}
                    label="Other Notes"
                    disabled={true}
                    component={renderTextField}
                  />
                </div>)}
              </div>
              <div className="row">
                <div className="col-sm-12">
                    <Field
                      name="DataCollection"
                      type="text"
                      fullWidth={true}
                      label="Progree information/data collection"
                      rowsCount = {6}
                      // autoHeight={true}
                      disabled={true}
                      component={renderTextArea}
                      
                    />
                  </div>
                  <div className="col-sm-12">
                    <Field
                      name="PlanForNextSession"
                      type="text"
                      fullWidth={true}
                      label="Plan for next session and opportunites for practice"
                      rowsCount = {6}
                      // autoHeight={true}
                      disabled={true}
                      component={renderTextArea}
                      
                    />
                  </div>
                  <div className="col-sm-12">    
                    <Field
                      name="DateOfNextSession"
                      placeholder="Date Of Next Session"
                      component={renderDateField}
                      locale="en-US"
                      openToYearSelection={true}
                      minDate={new Date()}
                      selected={this.state.DateOfNextSession}
                      onDateChange={this.onDateChange} />
                  </div>
              </div>             

              <div className = "row">
                <div className="col-sm-12">
                  <div className="panel_title mt-24  mb-20">
                    <h3>Diagnosis</h3>
                    <i className="flaticon flaticon-gym"></i>
                  </div>
                </div>
              </div>
              <div className="table-responsive mt-15">
                <Table className={tableClass1}
                  height={this.state.height}
                  fixedHeader={this.state.fixedHeader}
                  fixedFooter={this.state.fixedFooter}
                  selectable={this.state.selectable}
                  multiSelectable={this.state.multiSelectable}
                >
                  <TableHeader
                    displaySelectAll={false}
                    adjustForCheckbox={false}
                  >
                    <TableRow>
                      <TableHeaderColumn width="30%">Diagnosis Code</TableHeaderColumn>
                      <TableHeaderColumn width="70%">Description</TableHeaderColumn>
                    </TableRow>
                  </TableHeader>
                  <TableBody
                    displayRowCheckbox={false}
                    deselectOnClickaway={this.state.deselectOnClickaway}
                    showRowHover={this.state.showRowHover}
                    stripedRows={this.state.stripedRows}
                  >
                    {this.renderDiagnosis()}
                  </TableBody>
                </Table>
              </div>
              <div className = "row">
                <div className="col-sm-12">
                  <div className="panel_title mt-24  mb-20">
                    <h3>Service Codes</h3>
                    <i className="flaticon flaticon-interface-2"></i>
                  </div>
                </div>
              </div>
              <div className="table-responsive mt-15">
                <Table className={tableClass1}
                  height={this.state.height}
                  fixedHeader={this.state.fixedHeader}
                  fixedFooter={this.state.fixedFooter}
                  selectable={this.state.selectable}
                  multiSelectable={this.state.multiSelectable}
                >
                  <TableHeader
                    displaySelectAll={false}
                    adjustForCheckbox={false}
                  >
                    <TableRow>
                      <TableHeaderColumn width="20%">Service Code</TableHeaderColumn>
                      <TableHeaderColumn width="30%">Modifiers</TableHeaderColumn>
                      <TableHeaderColumn width="50%">Description</TableHeaderColumn>
                    </TableRow>
                  </TableHeader>
                  <TableBody
                    displayRowCheckbox={false}
                    deselectOnClickaway={this.state.deselectOnClickaway}
                    showRowHover={this.state.showRowHover}
                    stripedRows={this.state.stripedRows}
                  >
                    {this.renderCpt()}
                  </TableBody>
                </Table>
              </div>
              { this.state.EmployeeSign.Bytes || this.state.ClientSign.Bytes || this.state.GuardianSign.Bytes ?
                <div className="row">
                  <div className="col-12">
                    <div className="panel_title mt-24  mb-20">
                      <h3>Signature</h3>
                      <i className="flaticon flaticon-medical-1"></i>
                    </div>
                  </div>
                  {
                    this.state.EmployeeSign.Bytes ?
                      <div className="col-sm-12 col-md-4">
                        <div id="showCanvasImageEmployee">

                          <div className="row">
                            <div className="col-12">
                              <div className="sign">
                                <img className="img-fluid" src={`data:image/png;base64,${this.state.EmployeeSign.Bytes}`} alt={''} />
                                <h3>{this.state.EmployeeSign.Name} <span>(Employee)</span></h3>
                                <p><span>Date :</span> {showFormatedDateandTime(this.state.EmployeeSign.Date)}</p>
                                {/* <p><span>Latitude :</span> {this.state.EmployeeSign.Latitude}</p>
                                <p><span>Longitude :</span> {this.state.EmployeeSign.Longitude}</p> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      : ''
                  }
                  {this.state.ClientSign.Bytes ?
                    <div className="col-sm-12 col-md-4">
                      <div id="showCanvasImageClient">
                        <div className="row">
                          <div className="col-12">
                            <div className="sign">
                              <img className="img-fluid" src={`data:image/png;base64,${this.state.ClientSign.Bytes}`} alt={''} />
                              <h3>{this.state.ClientSign.Name} <span>(Client)</span></h3>
                              <p><span>Date :</span> {showFormatedDateandTime(this.state.ClientSign.Date)}</p>
                              {/* <p><span>Latitude :</span> {this.state.ClientSign.Latitude}</p>
                              <p><span>Longitude :</span> {this.state.ClientSign.Longitude}</p> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    : ''
                  }
                  {this.state.GuardianSign.Bytes ?
                    <div className="col-sm-12 col-md-4">
                      <div id="showCanvasImageGuadian">

                        <div className="row">
                          <div className="col-12">
                            <div className="sign">
                              <img className="img-fluid" src={`data:image/png;base64,${this.state.GuardianSign.Bytes}`} alt={''} />
                              <h3>{this.state.GuardianSign.Name} <span>(Guardian)</span></h3>
                              <p><span>Date :</span> {showFormatedDateandTime(this.state.GuardianSign.Date)}</p>
                              {/* <p><span>Latitude :</span> {this.state.GuardianSign.Latitude}</p>
                              <p><span>Longitude :</span> {this.state.GuardianSign.Longitude}</p> */}
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                    : ''
                  }
                </div>
                : ''}
            </form>
          </div>
        </div>
      </div>
    );
  }
}
const selector = formValueSelector('EncounterForm');
EncounterForm = reduxForm({
  form: 'EncounterForm',
  enableReinitialize: true,
})(EncounterForm);
function mapStateToProps(state) {
  let initialData = {};
  let appointmentTime = null;
  if (state.patient.singleEncounter && state.patient.singleEncounter) {
    if (state.patient.singleEncounter.sessionNotes_EBSPA_EarlyIntervention) {
        initialData['Goals'] = state.patient.singleEncounter.sessionNotes_EBSPA_EarlyIntervention.goals; 
        initialData['ChildOutcomeUpdate'] = state.patient.singleEncounter.sessionNotes_EBSPA_EarlyIntervention.childOutcomeUpdate; 
        initialData['ActivitiesAndRoutines'] = state.patient.singleEncounter.sessionNotes_EBSPA_EarlyIntervention.activitiesAndRoutines; 
        initialData['DataCollection'] = state.patient.singleEncounter.sessionNotes_EBSPA_EarlyIntervention.dataCollection; 
        initialData['PlanForNextSession'] = state.patient.singleEncounter.sessionNotes_EBSPA_EarlyIntervention.planForNextSession; 
        initialData['ServiceCoordinatorName'] = state.patient.singleEncounter.sessionNotes_EBSPA_EarlyIntervention.serviceCoordinatorName; 
        initialData['DateOfNextSession'] = state.patient.singleEncounter.sessionNotes_EBSPA_EarlyIntervention.dateOfNextSession; 

        // DiagnosticEvaluation_ClinicalService_EBS
        initialData['OT'] = state.patient.singleEncounter.sessionNotes_EBSPA_EarlyIntervention.ebspA_EarlyIntervention_TypeofService.ot; 
        initialData['PT'] = state.patient.singleEncounter.sessionNotes_EBSPA_EarlyIntervention.ebspA_EarlyIntervention_TypeofService.pt; 
        initialData['ST'] = state.patient.singleEncounter.sessionNotes_EBSPA_EarlyIntervention.ebspA_EarlyIntervention_TypeofService.st; 
        initialData['SI'] = state.patient.singleEncounter.sessionNotes_EBSPA_EarlyIntervention.ebspA_EarlyIntervention_TypeofService.si; 
        initialData['OtherTypeofService'] = state.patient.singleEncounter.sessionNotes_EBSPA_EarlyIntervention.ebspA_EarlyIntervention_TypeofService.otherTypeofService; 
        initialData['OtherTypeofServiceNotes'] = state.patient.singleEncounter.sessionNotes_EBSPA_EarlyIntervention.ebspA_EarlyIntervention_TypeofService.otherTypeofServiceNotes; 

        // BT_EvidenceBasedInterventionsUsed_BESTABA
        initialData['Initial'] = state.patient.singleEncounter.sessionNotes_EBSPA_EarlyIntervention.ebspA_EarlyIntervention_TypeofSession.initial; 
        initialData['Ongoing'] = state.patient.singleEncounter.sessionNotes_EBSPA_EarlyIntervention.ebspA_EarlyIntervention_TypeofSession.ongoing; 
        initialData['OtherTypeofSession'] = state.patient.singleEncounter.sessionNotes_EBSPA_EarlyIntervention.ebspA_EarlyIntervention_TypeofSession.otherTypeofSession; 
        initialData['OtherTypeofSessionNotes'] = state.patient.singleEncounter.sessionNotes_EBSPA_EarlyIntervention.ebspA_EarlyIntervention_TypeofSession.otherTypeofSessionNotes; 
        

         // BT_EvidenceBasedInterventionsUsed_BESTABA
         initialData['DirectTeaching'] = state.patient.singleEncounter.sessionNotes_EBSPA_EarlyIntervention.ebspA_EarlyIntervention_StrategiesUsed.directTeaching; 
         initialData['Demonstration'] = state.patient.singleEncounter.sessionNotes_EBSPA_EarlyIntervention.ebspA_EarlyIntervention_StrategiesUsed.demonstration; 
         initialData['GuidedPractice'] = state.patient.singleEncounter.sessionNotes_EBSPA_EarlyIntervention.ebspA_EarlyIntervention_StrategiesUsed.guidedPractice; 
         initialData['CaregiverPractice'] = state.patient.singleEncounter.sessionNotes_EBSPA_EarlyIntervention.ebspA_EarlyIntervention_StrategiesUsed.caregiverPractice; 
         initialData['ProblemSolving'] = state.patient.singleEncounter.sessionNotes_EBSPA_EarlyIntervention.ebspA_EarlyIntervention_StrategiesUsed.problemSolving; 
         initialData['Reflection'] = state.patient.singleEncounter.sessionNotes_EBSPA_EarlyIntervention.ebspA_EarlyIntervention_StrategiesUsed.reflection; 
         initialData['OtherStrategiesUsed'] = state.patient.singleEncounter.sessionNotes_EBSPA_EarlyIntervention.ebspA_EarlyIntervention_StrategiesUsed.otherStrategiesUsed; 
         initialData['OtherStrategiesUsedNotes'] = state.patient.singleEncounter.sessionNotes_EBSPA_EarlyIntervention.ebspA_EarlyIntervention_StrategiesUsed.otherStrategiesUsedNotes; 
         
    }
    if (state.patient.singleEncounter.patientEncounterDiagnosisCodes) {
      initialData['diagnosisArray'] = state.patient.singleEncounter.patientEncounterDiagnosisCodes;
    }
    if (state.patient.singleEncounter.patientEncounterServiceCodes) {
      initialData['CPTTableData'] = state.patient.singleEncounter.patientEncounterServiceCodes;
    }

    // if(state.patient.singleEncounter.appointmentStartDateTime){
    //   let startTimehours = state.patient.singleEncounter.appointmentStartDateTime.substr(11, 2);
    //   let endTimehours = state.patient.singleEncounter.appointmentEndDateTime.substr(11, 2);
    //   let formattedStartTimehours = parseInt(startTimehours, 10) >= 12 ?
    //     (parseInt(startTimehours, 10) - 12 < 10 ?
    //       `0${parseInt(startTimehours, 10) - 12}`
    //       : startTimehours)
    //     : startTimehours;
    //   let formattedEndTimehours = parseInt(endTimehours, 10) >= 12 ? (parseInt(endTimehours, 10) - 12 < 10 ? `0${parseInt(endTimehours, 10) - 12}` : endTimehours) : endTimehours;
    //   let AmPmOfStartTime = parseInt(startTimehours, 10) >= 12 ? 'pm' : 'am';
    //   let AmPmOfEndTime = parseInt(endTimehours, 10) >= 12 ? 'pm' : 'am';
    //   appointmentTime = `${formattedStartTimehours}:${state.patient.singleEncounter.appointmentStartDateTime.substr(14, 2)} ${AmPmOfStartTime} - ${formattedEndTimehours}:${state.patient.singleEncounter.appointmentEndDateTime.substr(14, 2)} ${AmPmOfEndTime}`;
    //   initialData['appointmentTime'] = appointmentTime;
    // }

    // console.log('state.patient.singleEncounter.............', state.patient.singleEncounter);

    if (state.patient.singleEncounter.startDateTime) {
      let startTimehours = state.patient.singleEncounter.startDateTime.substr(11, 2);
      let endTimehours = state.patient.singleEncounter.endDateTime.substr(11, 2);
      let formattedStartTimehours = parseInt(startTimehours, 10) >= 12 ? (parseInt(startTimehours, 10) - 12 < 10 ? `0${parseInt(startTimehours, 10) - 12}` : startTimehours) : startTimehours;
      let formattedEndTimehours = parseInt(endTimehours, 10) >= 12 ? (parseInt(endTimehours, 10) - 12 < 10 ? `0${parseInt(endTimehours, 10) - 12}` : endTimehours) : endTimehours;

      let AmPmOfStartTime = parseInt(startTimehours, 10) >= 12 ? 'pm' : 'am';
      let AmPmOfEndTime = parseInt(endTimehours, 10) >= 12 ? 'pm' : 'am';
      appointmentTime = `${formattedStartTimehours}:${state.patient.singleEncounter.startDateTime.substr(14, 2)} ${AmPmOfStartTime} - ${formattedEndTimehours}:${state.patient.singleEncounter.endDateTime.substr(14, 2)} ${AmPmOfEndTime}`;
      initialData['appointmentTime'] = appointmentTime;
    }


    initialData['locationName'] = state.patient.singleEncounter.locationName;
    initialData['staffName'] = state.patient.singleEncounter.staffName;
    initialData['appointmentDate'] = state.patient.singleEncounter.patientAppointment.startDateTime;
    initialData['PatientLocationName'] = state.patient.singleEncounter.PatientLocationName;
    initialData['serviceEndTime'] = moment(state.patient.singleEncounter.patientAppointment.endDateTime).format('YYYY-MM-DD') + 'T' + moment(state.patient.singleEncounter.patientAppointment.endDateTime).format('HH:mm:ss');
    initialData['serviceStartTime'] = moment(state.patient.singleEncounter.patientAppointment.startDateTime).format('YYYY-MM-DD') + 'T' + moment(state.patient.singleEncounter.patientAppointment.startDateTime).format('HH:mm:ss');

  }
  return {
    selectorOtherTypeofService: selector(state, 'OtherTypeofService'),
    selectorOtherTypeofSession: selector(state, 'OtherTypeofSession'),
    selectorOtherStrategiesUsed: selector(state, 'OtherStrategiesUsed'),
    singleEncounter: state.patient.singleEncounter,
    initialValues: initialData,
    master_data: state.soap.master_data,
    dateOfNextSession: initialData && initialData.DateOfNextSession ? initialData.DateOfNextSession : '',
  };
}
export default connect(mapStateToProps, { getPatientSingleEncounters, getMasterData })(EncounterForm);



// WEBPACK FOOTER //
// ./src/modules/patients/components/Encounter/SessionNotes_Encounter_EarlyIntervention_EBSPA.js